import styled from "@emotion/styled";
import isPropValid from '@emotion/is-prop-valid';
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const ContentGrid = styled.div`
    display:flex;
    gap:3rem;
`;

export const Content = styled.div`
    width:33%;
    min-width:480px;
    padding:1.2rem 2rem;
    background:#fff;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    height:75vh;
    margin-top: 1rem;
    display:flex;
    flex-direction: column;
    position: relative;
`;

export const TitleLeft = styled.div`
    font-size: 20px;
    font-weight: 600;
    display:flex;
    align-items: center;

`;

export const PickType = styled.div`
    display:flex;
    gap:3rem;
    margin-top: 1rem;
`;


export const ChoiceItem = styled.div<{selected?:boolean}>`
    display:flex;
    gap:1rem; 
    align-items: center;
    font-size: 16px;
    cursor: pointer;

    div{
        width:18px;
        height:18px;
        background:${props => props.selected?"#2A848E":"#fff"};
        border-radius: 50%;
        border:1px solid #2A848E;
    }
`;

export const BottomContent = styled.div`
    display:flex;
    flex-direction: column;
    gap:0.5rem;
`;

export const TextArea = styled.div`
    width:100%;
    border:1px solid #acacac;
    border-radius: 5px;
    padding:6px 10px 0 10px;
    min-height: 96px;

    textarea{
        width:100%;
        resize:none;
        border:none;
        outline:none;
        font-size: 14px;
        scrollbar-width: thin;
        height:40px;

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: #d8d8d8;
    }
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
    }

    > div{
        min-height:38px;
    }
`;

export const BtnRow = styled.div`
    display:flex;
    justify-content: end;
    gap:2rem;
`;

export const ButtonAdd = styled.button`
    font-size: 14px;
    font-weight: 500;
    background:transparent;
    border:1px solid #2A848E;
    color:#2A848E;
    padding:0.4rem 3rem;
    border-radius: 5px;

    &:hover{
        background:#2A848E;
        color:#fff;
        opacity: 0.8;
    }

    &:disabled{
        background-color: transparent!important;
        border:1px solid #acacac;
        color:#acacac;
        cursor:not-allowed;
    }
`;


export const Tags = styled.div<{pad?:boolean, disableText?:boolean}>`
    width:100%;
    display:inline-flex;
    flex-wrap: wrap;
    gap:4px 6px;
    padding: 8px 0;
    margin-top: auto;
`; 

export const Tag = styled('div', {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'display',
})<{bgColor?:string, c?:boolean, delete?:boolean, display?:boolean}>`
    background: ${props => props.bgColor?"#" + props.bgColor:"#959595"};
    color: ${props => props.c?"black":"#fff"};
    font-size: 12px;
    padding: ${props => props.delete?"2px 6px 2px 12px":"2px 12px"};
    border-radius: 5px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    cursor: pointer;
    display: ${props => props.display?"none":"flex"};
    align-items: center;
    transition: all 0.1s ease-in-out;
    
    div{
        margin-left: 6px;
        height:14px; 
        aspect-ratio: 1 / 1;
        border:1px solid ${props => props.c?"black":"#fff"};
        border-radius: 5px;
        display:flex;
        align-items: center;
        justify-content: center;

        svg{
            height:50%;
            path{
                fill: ${props => props.c?"black":"#fff"};
            }
        }
    }

    &:hover{
        opacity: 0.9;
    }
`;

